<template>
  <v-alert
    data-testid="ai-chat-view-error-alert"
    :class="alertClass"
    border="left"
    type="info"
    color="red"
    text
  >
    <span :class="[...textClass]">
      {{ errorText }}
    </span>
  </v-alert>
</template>

<script>
export default {
  name: 'AIErrorAlert',

  props: {
    errorType: {
      type: Number,
    },

    textClass: {
      type: Array,
      default: () => ['ma-0', 'pa-0'],
    },

    alertClass: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {}
  },

  computed: {
    errorText() {
      if (this.errorType === 403) {
        return this.$t('ai_features.chat_view.not_allowed')
      }
      return this.$t('ai_features.chat_view.insufficient_tokens')
    },
  },
}
</script>
